import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformType} from '../../../../global/util/enum/InformType';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentService} from '../../../service/document.service';
import {Workflow} from '../../../model/Workflow';
import {Document} from '../../../model/Document';
import {PersonService} from '../../../service/person.service';
import {Person} from '../../../model/Person';
import {Constant} from '../../../../global/util/Constant';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {DocumentUtil} from '../../../../global/util/DocumentUtil';
import {SignType} from '../../../../global/util/enum/SignType';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {AddEditPersonComponent} from '../../person/add-edit-person/add-edit-person.component';
import {AuthService} from '../../../service/auth/auth.service';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {StringUtil} from '../../../../global/util/StringUtil';
import {Router} from '@angular/router';
import {ApplicationService} from '../../../service/application.service';
import {Dialog} from '../../../../global/util/Dialog';
import {ParticipantType} from '../../../../global/util/enum/ParticipantType';
import {TypeSignature} from '../../../../global/util/TypeSignature';
import {WorkflowType} from '../../../../global/util/WorkflowType';
import {TranslateService} from '@ngx-translate/core';
import {AddManageDocumentComponent} from '../add-manage-document/add-manage-document.component';
import {Management} from '../../../model/Management';
import {WorkflowService} from '../../../service/workflow.service';
import {File4Participant} from '../../../model/others/File4Participant';
import {WorkflowDataService} from '../../../service/data/workflow-data.service';

@Component({
  selector: 'app-add-document-one',
  templateUrl: './add-document-one.component.html',
  styleUrls: ['./add-document-one.component.css']
})

export class AddDocumentOneComponent implements OnInit, OnDestroy {
  public loading: boolean;
  public documentForm: FormGroup;
  public document = new Document();
  public workflows: Workflow[] = [];
  public workflowSelected = new Workflow();
  public people: Person[] = [];
  public progressUpdate = 0;
  public enterpriseIdSelected: number;
  public uploading = false;
  private type = 1;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_USER = Constant.ROLE_USER;
  public ROLE_SIMPLE = Constant.ROLE_SIMPLE;
  public title = 'TITLE.SIGN-ONE-TO-ONE';
  public document2Modify: Document;
  public signType = SignType.One2One;
  public readonly OPERATION_SIGN_ID = 1;
  public manageDocumentChecked: boolean;
  public hasOneSignSignature: boolean;
  public managements: Management[] = [];
  public typeLoadSelected: number;
  public isTypeFile = true;
  public documents: any[] = [];
  public message: string;
  public hasDocumentSelection2Sign = false;

  constructor(public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private formBuilder: FormBuilder,
              public documentService: DocumentService,
              public personService: PersonService,
              public workflowService: WorkflowService,
              private router: Router,
              public authenticationService: AuthService,
              private applicationService: ApplicationService,
              private workflowDataService: WorkflowDataService,
              public translate: TranslateService) {
    this.createForm();
  }

  ngOnInit() {
    this.message = this.translate.instant('MESSAGE.NEW-UPLOAD-DOCUMENT');
    this.typeLoadSelected = 1;
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN)) {
      // this.workflows = LocalStorage.getWorkflowsExtraBy(this.enterpriseIdSelected).sort();
      this.workflows = this.workflowDataService.getWorkflows().sort();
      console.log(this.workflows);
    } else {
      this.workflows = LocalStorage.getWorkflowsByPerson().sort();
    }
    this.workflows = this.workflows.filter(workflow => !workflow.send2Visualization).sort();
    if (this.isDocModification) {
      this.document.subject = this.document2Modify.subject;
      const workflow1 = this.workflows.find(workflow => workflow.id === this.document2Modify.workflowId);
      if (workflow1.dynamic === Constant.STATICALLY && workflow1.batch === Constant.ONE2ONE) {
        this.signType = SignType.One2One;
        this.workflows = DocumentUtil.extractOnlyNecesaryWorkflowsBy(this.workflows, SignType.One2One).filter(workflow => workflow.id === this.document2Modify.workflowId).sort();
      } else if (workflow1.dynamic === Constant.STATICALLY && workflow1.batch === Constant.BATCH) {
        this.signType = SignType.Batch;
        this.workflows = DocumentUtil.extractOnlyNecesaryWorkflowsBy(this.workflows, SignType.Batch).filter(workflow => workflow.id === this.document2Modify.workflowId).sort();
      }
    } else {
      this.workflows = DocumentUtil.extractOnlyNecesaryWorkflowsBy(this.workflows, SignType.One2One).sort();
    }
    this.workflowSelected = this.workflows[0];
    const interval = setInterval(() => {
      if (!this.authenticationService.isAuthenticated()) {
        clearInterval(interval);
        this.activeModal.close(InformType.Anything);
      }
    }, 300);
  }

  ngOnDestroy() {
    const items = [
      'others',
      'identificationdocuments',
      'datetypes',
      'managementtypes'];
    LocalStorage.removeItems(items);
  }

  public isEditable(person: Person): boolean {
    if (person._more) {
      if (person._more.incompleteData && this.OPERATION_SIGN_ID === person._more.operationId) {
        return person._more.incompleteData;
      } else {
        return Constant.INVITED === person._more.participantType;
      }
    } else {
      return false;
    }
  }

  public isEditUser(person: Person): boolean {
    if (person._more) {
      if (person._more.incompleteData && ParticipantType.Invited !== person._more.participantType && this.OPERATION_SIGN_ID === person._more.operationId) {
        return person._more.incompleteData;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
   * Carga los datos necesarios para el módulo actual y luego abre el modal para agregar/editar persona
   */
  public loadRequiredDataAndOpenModal(person: Person) {
    this.loading = true;
    this.title = this.translate.instant('TITLE.SIGN-ONE-TO-ONE');
    const url = Constant.ROOT_API_V1.concat('/required-data?component=add-person');
    this.applicationService.get(url).subscribe((next: any) => {
      this.loading = false;
      LocalStorage.setUpEmbeddedInfo(next);
      this.openAddSearchPersonModal(person);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  public openAddSearchPersonModal(person: Person) {
    const modalRef = this.modalService.open(AddEditPersonComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    if (ParticipantType.Invited !== person._more.participantType) {
      modalRef.componentInstance.personReceived = person;
      modalRef.componentInstance.purpose4Form = Constant.EDIT_ON_DOCS;
      modalRef.componentInstance.addRubric = false;
      modalRef.componentInstance.enterpriseIdSelected = person.enterpriseId;
      modalRef.componentInstance.incompleteData = person._more.incompleteData;
      modalRef.componentInstance.stampRubric = false;
    } else {
      const signatureOrderNumber = this.people.findIndex(person1 => TypeSignature.DIGITAL === person1._more.typeSignature || TypeSignature.CLOUD === person1._more.typeSignature);
      const signatureElectronicOrder = this.people.findIndex(person1 => person1.id === person.id && TypeSignature.ELECTRONIC === person._more.typeSignature);
      modalRef.componentInstance.personReceived = new Person();
      modalRef.componentInstance.purpose4Form = Constant.ADD_ON_DOCS;
      // Si el primer participante es una firma digital, debería obligarle a poner las demás rúbricas
      modalRef.componentInstance.addRubric = signatureElectronicOrder >= signatureOrderNumber && signatureOrderNumber > -1;
      modalRef.componentInstance.enterpriseIdSelected = LocalStorage.getEnterpriseIdView();
      modalRef.componentInstance.stampRubric = person._more.hasStampRubric;
    }
    modalRef.componentInstance.typeSignature = person._more.typeSignature;
    modalRef.componentInstance.typePerson = person._more.typePerson;
    modalRef.componentInstance.hasImagesDocument = person._more.hasImagesDocument;
    modalRef.result.then((result) => {
      if (Constant.CANCEL === result) {
        return;
      }
      if (Constant.EDIT_ON_DOCS === result) {
        person._more.incompleteData = false;
        return;
      }
      person.id = result.id;
      person.documentNumber = result.documentNumber;
      person.fullname = result.fullname;
      person.replaceable = result.replaceable;
      person.replaced = Constant.REPLACED;
      if (TypeSignature.CLOUD === person._more.typeSignature || TypeSignature.ELECTRONIC === person._more.typeSignature) {
        person._more.incompleteData = false;
      }
      const title = this.translate.instant('TITLE.PERSON');
      if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, title);
      } else if (InformType.Success === result) {
        Dialog.show(InformType.Success, title);
      } else if (InformType.Info === result) {
        Dialog.show(InformType.Info, title);
      }
    });
  }

  public save(): void {
    this.title = this.translate.instant('TITLE.SIGN-ONE-TO-ONE');
    if (this.documentForm.invalid) {
      Object.values(this.documentForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    const replacements = this.getReplacementsOf(this.people);
    const typePersons = this.getTypePerson(this.people);
    const managements = this.getManagementsOf(this.managements);
    const formData = new FormData();
    formData.append('type', String(this.type));
    formData.append('subject', this.document.subject);
    formData.append('workflowId', String(this.workflowSelected.id));
    formData.append('replacements', replacements);
    formData.append('managements', managements);
    formData.append('typePersons', typePersons);
    for (const doc of this.documents) {
      formData.append('files', doc[0].file);
    }
    // Se agrega al elección de documentos a firmar por participante (Firmante.).
    const participants: File4Participant[] = [];
    if (this.hasDocumentSelection2Sign) {
      const participantOrders: any[] = [];
      for (const person of this.people) {
        participantOrders.push(person._more.orderParticipant);
      }
      for (const order of participantOrders) {
        let isParticipantAssigned = false;
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < this.documents.length; index++) {
          const docParticipants = this.documents[index][0].participants;
          const regex = new RegExp(order.toString(), 'g');
          if (docParticipants !== '' && regex.test(docParticipants)) {
            isParticipantAssigned = true;
            break;
          }
        }
        if (!isParticipantAssigned) {
          Dialog.show(InformType.Warning, 'Documentos a firmar', `Por favor, seleccione al menos un documento para el firmante ${order}.`);
          return;
        }
      }
      // tslint:disable-next-line:prefer-for-of
      for (let index = 0; index < this.documents.length; index++) {
        const docParticipants = this.documents[index][0].participants;
        const participant = new File4Participant();
        participant.participants = docParticipants;
        participants.push(participant);
      }
    }
    formData.append('documents2signByParticipant', JSON.stringify(participants));
    for (const person of this.people) {
      let message;
      if (TypeSignature.CLOUD === person._more.typeSignature && this.arrayDocument.controls.length > 10) {
        Dialog.show(InformType.Warning, 'OneSign', this.translate.instant('MESSAGE.LIMIT-EXCEEDS-10-AT-MOST'));
        return;
      }
      message = this.translate.instant('MESSAGE.COMPLETE-MISSING-DATA-PARTICIPANT');
      if (TypeSignature.CLOUD === person._more.typeSignature && person._more.incompleteData) {
        if (person.cellphone === undefined || person.cellphone === '') {
          Dialog.show(InformType.Warning, 'OneSign', message + person.fullname + ', ' + this.translate.instant('MESSAGE.ENTER-PHONE-NUMBER'));
        } else if (!person._more.hasImagesDocument) {
          Dialog.show(InformType.Warning, 'OneSign', message + person.fullname + ', ' + this.translate.instant('MESSAGE.ENTER-DOCUMENT-IDENTIFICATION-IMAGE'));
        } else if (person.lastname2 === undefined || person.lastname2.trim() === '') {
          Dialog.show(InformType.Warning, 'OneSign', message + person.fullname + ', ' + this.translate.instant('MESSAGE.MOTHERS-LAST-NAME-ARE-REQUIRED'));
        }
        return;
      }
      const signatureOrderNumber = this.people.findIndex(person1 => TypeSignature.DIGITAL === person1._more.typeSignature
        || TypeSignature.CLOUD === person1._more.typeSignature);
      const signatureElectronicOrder = this.people.findIndex(person1 => person1.id === person.id);
      if (TypeSignature.ELECTRONIC === person._more.typeSignature && person._more.hasStampRubric && this.OPERATION_SIGN_ID === person._more.operationId && person._more.incompleteData) {
        if (signatureOrderNumber !== -1 && signatureOrderNumber < signatureElectronicOrder) {
          Dialog.show(InformType.Warning, this.title, message + person.fullname + ', ' + this.translate.instant('MESSAGE.ENTER-RUBRIC'));
          return;
        }
      }
    }
    let url;
    if (this.isDocModification) {
      formData.append('reasonModification', this.document.reasonModification);
      url = Constant.ROOT_API_V1.concat('/documents/', String(this.document2Modify.id), '/modify');
    } else {
      url = Constant.ROOT_API_V1.concat('/documents');
    }
    this.documentService.uploadTo(url, formData).subscribe((event: HttpEvent<any>) => {
      this.uploading = true;
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.uploading = false;
          this.activeModal.close(InformType.Success);
          break;
      }
    }, error => {
      this.progressUpdate = 0;
      this.processError(this.title, error);
    });
  }

  private getReplacementsOf(people: Person[]): string {
    let replacements = '';
    for (const person of people) {
      if (person._more) {
        const participantType = person._more.participantType;
        if (Constant.INVITED === participantType) {
          replacements += String(person._more.orderParticipant)
            .concat(',')
            .concat(String(person.id))
            .concat(',')
            .concat('0')
            .concat('|');
        }
      }
    }
    return StringUtil.removeLastCharacter(replacements);
  }

  private getTypePerson(people: Person[]): string {
    let replacements = '';
    for (const person of people) {
      if (person._more) {
        const isOneSignSignature = person._more.isOneSignSignature;
        if (isOneSignSignature) {
          replacements += String(person._more.orderParticipant)
            .concat(',')
            .concat(String(person.id))
            .concat(',')
            .concat(String(person._more.typePerson))
            .concat('|');
        }
      }
    }
    return StringUtil.removeLastCharacter(replacements);
  }

  cancel(): void {
    // TODO Investigate how to cancel upload request correctly
    this.activeModal.close();
  }

  private createForm() {
    this.documentForm = this.formBuilder.group(
      {
        workflow: [''],
        subject: ['', [Validators.required]],
        arrayDocument: this.formBuilder.array([]),
        reasonModification: [''],
        rubricFilename2Show: [''],
        rubricFilename2Show1: [''],
        typePerson: [''],
        typeLoad: [''],
        filename: []
      });
  }

  public isInvalidControl(ctrlName: string) {
    return this.documentForm.get(ctrlName).invalid && this.documentForm.get(ctrlName).touched;
  }

  public changeStatus1(event: any) {
    for (let index = 0; index < event.target.files.length; index++) {
      const fileSelected = (event.target as HTMLInputElement).files[index];
      if (!fileSelected.name.endsWith('.pdf')) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
        return;
      }
      const isUploadWorkflowType = WorkflowType.UPLOAD_TO_IOFESIGN === this.workflowSelected.type;
      if (isUploadWorkflowType) {
        this.changeStatusIGisUploadWorkflowType(fileSelected);
      }
      let orderParticipants = '';
      if (this.hasDocumentSelection2Sign) {
        const participants: any[] = [];
        for (const person of this.people) {
          participants.push(person._more.orderParticipant);
        }
        orderParticipants = participants.join(',');
      }
      const unique: any[] = [{
        file: fileSelected,
        filename: fileSelected.name,
        participants: orderParticipants,
      }];
      this.documents.push(unique);
    }
    event.target.value = '';
  }

  /**
   * Muestra mensaje de error de acuerdo a controlname
   */
  public getErrorMessageBy(controlName: string): string {
    const control = this.documentForm.get(controlName);
    const hasRequiredError = control.hasError('required');
    const hasPatternError = control.hasError('pattern');
    let actualValue;
    switch (controlName) {
      case 'subject':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.SUBJECT-ARE-REQUIRED');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-LAST-NAMES');
        }
        break;
      case 'rubricFilename2Show':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FILE-ARE-REQUIRED');
        }
        break;
      case 'rubricFilename2Show1':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FILE-ARE-REQUIRED');
        }
        break;
      case 'rubricFilename2Show2':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FILE-ARE-REQUIRED');
        }
        break;
    }
  }

  public changeStatusIGisUploadWorkflowType(selectedFile: any) {
    let message;
    let pattern;
    let translateTextDocumentNomenclature;
    let translateTextForExample;
    let translateTextForeignCard;
    let translateTextPassport;
    let translateTextContainEmailAddress;
    const filename = selectedFile.name.split('.pdf')[0];
    const electronicAddress = filename.split('#')[0];
    const email = filename.split('#')[1] || filename.split('#')[0];
    translateTextDocumentNomenclature = this.translate.instant('MESSAGE.ATTACH-DOCUMENT-FOLLOWING-NOMENCLATURE');
    translateTextForExample = this.translate.instant('MESSAGE.FOR-EXAMPLE');
    translateTextForeignCard = this.translate.instant('MESSAGE.FOREIGN-CARD');
    translateTextPassport = this.translate.instant('MESSAGE.PASSPORT');
    if (this.workflowSelected.notificateAfterUpload && this.workflowSelected.send2MailAfterUpload) {
      // TODO Hacer una verificación más exaustiva del uso de agrupadores '()' en las expresiones regulares
      pattern = '^([0][147]_[0-9]{8,11})#([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$';
      message = translateTextDocumentNomenclature +
        '<br><center>TIPODOC_NUMDOC#CORREOELECTRONICO.pdf</center>' +
        translateTextForExample + ':' +
        '<ul>' +
        '<li>Dni: 01_82635422#soporte@iofesac.pe.pdf</li>' +
        '<li>' + translateTextForeignCard + ': 04_236566542#soporte@iofesac.pe.pdf</li>' +
        '<li>' + translateTextPassport + ': 07_10568855262#soporte@iofesac.pe.pdf</li>' +
        '</ul>';
      if (!filename.match(pattern)) {
        Dialog.show(InformType.Warning,
          this.title,
          message);
        return;
      }
      if (this.hasInvitedParticipant) {
        this.setUpInvitedBy(electronicAddress);
      }
      this.documentForm.get('subject').setValue(filename);
    } else if (this.workflowSelected.notificateAfterUpload || this.workflowSelected.send2Visualization) {
      pattern = '^[0][147]_?[0-9]{8,11}$';
      message = translateTextDocumentNomenclature +
        '<br><center>TIPODOC_NUMDOC.pdf</center>' +
        translateTextForExample + ':' +
        '<ul>' +
        '<li>Dni: 01_82635422.pdf</li>' +
        '<li>' + translateTextForeignCard + ': 04_236566542.pdf</li>' +
        '<li>' + translateTextPassport + ': 07_10568855262.pdf</li>' +
        '</ul>';
      if ((!electronicAddress && !filename.match(pattern)) || !electronicAddress.match(pattern)) {
        Dialog.show(InformType.Warning,
          this.title,
          message);
        return;
      }
      if (this.hasInvitedParticipant) {
        this.setUpInvitedBy(electronicAddress);
      }
      this.documentForm.get('subject').setValue(electronicAddress);
    } else if (this.workflowSelected.send2MailAfterUpload) {
      translateTextContainEmailAddress = this.translate.instant('MESSAGE.ATTACH-DOCUMENT-CONTAIN-EMAIL-ADDRESS');
      pattern = '^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$';
      message = translateTextContainEmailAddress + '<br>' + translateTextForExample + ': soporte@iofesac.pe.pdf';
      if ((!email && !filename.match(pattern)) || !email.match(pattern)) {
        Dialog.show(InformType.Warning,
          this.title,
          message);
        return;
      }
      this.documentForm.get('subject').setValue(email);
    }
  }

  public loadParticipants() {
    this.hasDocumentSelection2Sign = false;
    this.loading = true;
    this.documents = [];
    const workflowId = String(this.workflowSelected.id);
    const personUrl = Constant.ROOT_API_V1
      .concat('/workflows/')
      .concat(workflowId)
      .concat('/detail');
    this.workflowService.get(personUrl).subscribe((next: any) => {
      if (next) {
        this.loading = false;
        this.hasOneSignSignature = next.hasOneSignSignature;
        this.hasDocumentSelection2Sign = next.hasDocumentSelection2Sign;
        this.loadParticipant1();
      }
    }, error => {
      this.hasDocumentSelection2Sign = false;
      this.loading = false;
      this.processError(this.translate.instant('TITLE.PARTICIPANTS'), error);
    });
  }

  public loadParticipant1() {
    const workflowId = String(this.workflowSelected.id);
    const personUrl = Constant.ROOT_API_V1
      .concat('/workflows/')
      .concat(workflowId)
      .concat('/people');
    this.personService.get(personUrl).subscribe((next: any) => {
      if (next._embedded) {
        this.loading = false;
        this.people = next._embedded.people;
        this.isWorkflowTypeOnlySigner();
        for (const person of this.people) {
          person._more.typePerson = 1;
          if (Constant.REPLACEABLE === person.replaceable) {
            person.replaced = Constant.NOT_REPLACED;
          } else {
            person.replaced = Constant.REPLACED;
          }
        }
      }
    }, error => {
      this.loading = false;
      this.processError(this.translate.instant('TITLE.PARTICIPANTS'), error);
    });
  }

  get areValidPeople() {
    return !(this.people.find(person => Constant.NOT_REPLACED === person.replaced) !== undefined);
  }

  get hasDocuments() {
    return this.documents.length > 0;
  }

  get arrayDocument() {
    return this.documentForm.get('arrayDocument') as FormArray;
  }

  public addRow() {
    const group = this.formBuilder.group({
      file: [null, [Validators.required]],
      filename: [''],
      workflow: [this.workflowSelected],
      documents2signByParticipant: ['']
    });
    this.arrayDocument.push(group);
  }

  public deleteRow(index: any) {
    this.documents.splice(index, 1);
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else if (HttpStatusCode.INSUFFICIENT_STORAGE === status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.LIMIT-STORAGE-EXCEEDED'), this.translate.instant('MESSAGE.LIMIT-STORAGE-EXCEEDED'));
      } else {
        this.uploading = false;
        Dialog.show(InformType.Danger, title, error.error.message);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  public isSigner(person: Person): boolean {
    return Constant.SIGN_OPTION === person._more.operationId;
  }

  get isDocModification(): boolean {
    return this.document2Modify !== undefined;
  }

  get isOne2OneDoc(): boolean {
    return SignType.One2One === this.signType;
  }

  get isUploadWorkflowType(): boolean {
    return WorkflowType.UPLOAD_TO_IOFESIGN === this.workflowSelected.type
      && (this.workflowSelected.notificateAfterUpload ||
        this.workflowSelected.send2MailAfterUpload ||
        this.workflowSelected.send2Visualization);
  }

  get isUploadWorkflowType1(): boolean {
    return WorkflowType.UPLOAD_TO_IOFESIGN === this.workflowSelected.type;
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  public applyValidators() {
    const control = this.documentForm.get('subject');
    if (!this.isUploadWorkflowType) {
      control.setValidators(Validators.required);
    } else {
      control.setValue('');
      control.clearValidators();
      // Limpiar y agregar un nuevo registro de archivo para eliminar las anteriores selecciones
      this.arrayDocument.clear();
    }
    control.updateValueAndValidity();
  }

  get workflowTypeMessage(): string {
    if (WorkflowType.SIGNATURE === this.workflowSelected.type) {
      return 'MESSAGE.SELECTED-SIGNATURE-ONLY-SIGN-DOCUMENTS';
    } else if (WorkflowType.SIGNATURE_AND_NOTIFICATION === this.workflowSelected.type) {
      return 'MESSAGE.SELECTED-SIGNATURE-AND-NOTIFICATION';
    } else if (WorkflowType.SIGNATURE_AND_NOTIFICATION_WITH_TEMPLATE === this.workflowSelected.type) {
      return 'MESSAGE.SELECTED-SIGNATURE-AND-NOTIFICATION-WITH-TEMPLATE';
    } else if (WorkflowType.UPLOAD_TO_IOFESIGN === this.workflowSelected.type) {
      if (this.workflowSelected.send2Visualization) {
        return 'MESSAGE.SELECTED-ALLOW-UPLOAD-DOC-TO-SIGN-NOTIFICATION-AND-SENT-TO-MAILBOX';
      } else if (!this.workflowSelected.notificateAfterUpload && !this.workflowSelected.send2MailAfterUpload) {
        return 'MESSAGE.SELECTED-ALLOW-UPLOAD-DOC-TO-SIGN-NOTIFICATION';
      } else if (this.workflowSelected.notificateAfterUpload && this.workflowSelected.send2MailAfterUpload) {
        return 'MESSAGE.SELECTED-NOTIFY-TO-ELECTRONIC-ADDRESS-AND-EMAIL';
      } else if (this.workflowSelected.notificateAfterUpload) {
        return 'MESSAGE.SELECTED-NOTIFY-TO-ELECTRONIC-ADDRESS';
      } else if (this.workflowSelected.send2MailAfterUpload) {
        return 'MESSAGE.SELECTED-NOTIFY-TO-EMAIL';
      }
    } else {
      return 'MESSAGE.SELECTED-WORKFLOW-NOT-DEFINED';
    }
  }

  /**
   * Busca a la persona asociada al 'domicilio electrónico' y lo reemplaza con el primer participante invitado
   * (en caso existiera) del documento. En caso de que la persona no exista se establecen los valores por defecto del
   * participante
   * @param electronicAddress El domicilio electrónico en el formato 'TIPODOC_NUMERODOCUMENTO'
   */
  private setUpInvitedBy(electronicAddress: string) {
    const idDocumentCode = electronicAddress.split('_')[0];
    const documentNumber = electronicAddress.split('_')[1];
    const identificationdocument = LocalStorage.getIdentificationdocument(idDocumentCode);
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/enterprises/', String(LocalStorage.getEnterpriseId()),
      '/enterprises/1/participanttypes/3/persontype/1',
      '/documenttype/', String(identificationdocument.id),
      '/documentnumber/', documentNumber,
      '/jobs/1/people');
    this.personService.get(url).subscribe((next: Person) => {
      const person = this.people.find(value => value.replaceable === Constant.REPLACEABLE);
      this.loading = false;
      person.id = next.id;
      person.documentNumber = next.documentNumber;
      person.fullname = next.fullname;
      person.replaceable = next.replaceable;
      person.replaced = Constant.REPLACED;
    }, () => {
      const person = this.people.find(value => value._more.participantType === Constant.INVITED);
      person.id = 1;
      person.documentNumber = '00000000';
      person.fullname = this.translate.instant('LABEL.PENDING');
      person.replaceable = 1;
      person.replaced = 0;
      this.loading = false;
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.PARTICIPANTS'), this.translate.instant('MESSAGE.WAS-NOT-FOUND-PARTICIPANT'));
    });
  }

  get hasInvitedParticipant(): boolean {
    return (this.people.find(value => value._more.participantType === Constant.INVITED)) !== undefined;
  }

  isWorkflowTypeOnlySigner() {
    if (this.workflowSelected._more) {
      this.manageDocumentChecked = this.workflowSelected.type === WorkflowType.SIGNATURE ? this.workflowSelected._more.manageDocumentChecked : false;
    } else {
      this.manageDocumentChecked = false;
    }
  }

  public isOneSignSignature(person: Person): boolean {
    return person._more.isOneSignSignature;
  }

  public isCompleteData(person: Person): boolean {
    if (Constant.INVITED === person._more.participantType) {
      return !person._more.incompleteData;
    }
    return false;

  }


  onChangeItem(person: any, index: number, event: any) {
    const participantOrders: string[] = this.documents[index][0].participants !== '' ? this.documents[index][0].participants.split(',') : [];
    console.log((event.target as HTMLInputElement).checked);
    if ((event.target as HTMLInputElement).checked) {
      // Verificar si el orderParticipant ya está agregado antes de añadirlo
      if (!participantOrders.includes(String(person._more.orderParticipant))) {
        participantOrders.push(String(person._more.orderParticipant));
      }
    } else {
      const indexToRemove = participantOrders.indexOf(String(person._more.orderParticipant));
      if (indexToRemove > -1) {
        participantOrders.splice(indexToRemove, 1); // Eliminar el elemento en ese índice
      }
    }
    this.documents[index][0].participants = participantOrders.length > 0 ? participantOrders.join(',') : '';
  }

  openModalManageDocument() {
    const modalRef = this.modalService.open(AddManageDocumentComponent, {
      backdrop: 'static',
    });
    modalRef.componentInstance.workflow = this.workflowSelected;
    modalRef.result.then(managements => {
      if (managements !== null) {
        this.managements = managements;
        Dialog.show(InformType.Success, this.translate.instant('TITLE.MANAGEMENT-DOCUMENT'), this.translate.instant('MESSAGE.THE-OPERATION-WAS-SUCCESSFULLY-COMPLETED'));
      }
    });
  }

  private getManagementsOf(managementList: Management[]) {
    let managements = '';
    for (const management of managementList) {
      managements += String(management.id)
        .concat('|');
    }
    return StringUtil.removeLastCharacter(managements);
  }

  public reload(isTypeFileSelected: number) {
    if (Number(isTypeFileSelected) === 1) {
      this.isTypeFile = true;
    } else {
      this.isTypeFile = false;
    }
  }
}
